import React from "react";
import { FormattedMessage } from "react-intl";
import "./PoaGuidelines.scss";

type Props = {};

const PoaGuidelines: React.FC<Props> = () => {
  return (
    <div className="poa-guidelines">
      <ul>
        <li>
          <FormattedMessage
            id="account-verification-proof-of-address-full-name"
            defaultMessage="Matches the full name you provided."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-proof-of-address-address"
            defaultMessage="Matches the address you provided."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-proof-of-address-date"
            defaultMessage="Is dated within the last three months."
          />
        </li>
      </ul>
    </div>
  );
};

export default PoaGuidelines;
